import { type OptionsFetchQueryResult, OptionsType } from '@openx/types/options.ts';
import type { UseQueryOptions } from '@openx/types/reactQuery.ts';
import { useTranslation } from 'react-i18next';

import { useOptionsFetch } from './generics/useOptionsFetch.tsx';

export function useMobileCarrierOptionsFetch(queryOptions?: UseQueryOptions<OptionsFetchQueryResult>) {
  const { t } = useTranslation();
  const {
    isLoading: isMobileCarrierOptionsLoading,
    data: mobileCarrierOptions,
    refetch: refetchMobileCarrierOptions,
  } = useOptionsFetch({
    errorMessage: t('Failed to fetch Mobile Carrier options'),
    optionType: OptionsType.MOBILE_CARRIER,
    queryOptions,
  });

  return {
    isMobileCarrierOptionsLoading,
    mobileCarrierOptions,
    refetchMobileCarrierOptions,
  };
}
